// ============================================================
// Sector configs for the shared vertical demo template
// Used by /demo-estetica and /demo-hair
// ============================================================
import {
  Sparkles, Scissors, Heart, Palette, Wand2, Crown, Star,
} from "lucide-react";

export const SECTOR_CONFIGS = {
  estetica: {
    key: "estetica",
    landingPath: "/estetica",
    landingLabel: "SmartBooker · Estetica",
    sectorParam: "estetica",
    plan: "benessere_pro",
    title: "SmartBooker · Estetica",
    seoTitle: "Demo SmartBooker per Centri Estetici",
    palette: {
      grad: "from-pink-500 to-rose-500",
      gradTo: "from-pink-600 to-rose-600",
      gradHover: "hover:from-pink-600 hover:to-rose-600",
      text: "text-pink-700",
      bg: "bg-pink-50",
      border: "border-pink-200",
      accent: "text-pink-600",
      ring: "ring-pink-400",
      icon: Sparkles,
    },
    cover: {
      badge: "DEMO INTERATTIVA · Centri Estetici",
      h1Pre: "Più clienti fedeli.",
      h1Highlight: "Più poltrone piene. Più fatturato.",
      sub: "In 2 minuti vedi punto per punto come SmartBooker raddoppia le prenotazioni del tuo centro estetico — dal trattamento prenotato online al cliente che torna tra 30 giorni.",
    },
    operators: [
      { name: "Sara Lombardi",   role: "Estetista",       color: "bg-pink-500"   },
      { name: "Giulia Conti",    role: "Estetista Senior", color: "bg-rose-500"  },
      { name: "Martina Greco",   role: "Onicotecnica",    color: "bg-amber-500"  },
    ],
    rooms: ["Cabina 1", "Cabina 2", "Sala manicure"],
    services: [
      { name: "Pulizia viso completa",      duration: 60, price: 55, highlight: false },
      { name: "Trattamento corpo anti-age", duration: 75, price: 95, highlight: true  },
      { name: "Manicure semipermanente",    duration: 45, price: 30, highlight: false },
      { name: "Pedicure curativo",          duration: 60, price: 40, highlight: false },
      { name: "Ceretta gambe",              duration: 30, price: 25, highlight: false },
      { name: "Massaggio rilassante 50'",   duration: 50, price: 50, highlight: false },
    ],
    appointments: [
      { time: "10:00", room: 0, op: 0, service: "Pulizia viso completa",   patient: "Anna Bianchi",   color: "bg-pink-100 dark:bg-pink-900/40 border-pink-500" },
      { time: "10:30", room: 1, op: 1, service: "Massaggio rilassante",    patient: "Laura Russo",    color: "bg-rose-100 dark:bg-rose-900/40 border-rose-500" },
      { time: "11:00", room: 2, op: 2, service: "Manicure semipermanente", patient: "Sofia Greco",    color: "bg-amber-100 dark:bg-amber-900/40 border-amber-500" },
      { time: "15:00", room: 0, op: 0, service: "Trattamento corpo",       patient: "Elena Rossi",    color: "bg-pink-100 dark:bg-pink-900/40 border-pink-500" },
      { time: "15:30", room: 1, op: 1, service: "Pulizia viso",            patient: "Maria Costa",    color: "bg-rose-100 dark:bg-rose-900/40 border-rose-500" },
      { time: "17:00", room: 2, op: 2, service: "Pedicure curativo",       patient: "Chiara Neri",    color: "bg-amber-100 dark:bg-amber-900/40 border-amber-500" },
    ],
    liveBooking: {
      time: "16:00", room: 0, op: 0,
      service: "Pulizia viso completa", patient: "Valeria Conti",
      color: "bg-emerald-100 dark:bg-emerald-900/40 border-emerald-500",
      label: "📲 Nuova prenotazione · Valeria · 16:00",
    },
    pains: [
      { text: "Telefono che squilla mentre stai trattando una cliente",         loss: "10-15 chiamate perse/giorno" },
      { text: "Clienti che non si presentano e cabine vuote",                   loss: "3-4 no-show a settimana" },
      { text: "Promemoria scritti a mano per ogni appuntamento",                loss: "2 ore perse al giorno" },
      { text: "Clienti che spariscono dopo 2 trattamenti e non tornano più",    loss: "60% non torna entro 60 giorni" },
      { text: "Pacchetti trattamenti gestiti su carta o agenda",                loss: "Errori sui crediti residui" },
      { text: "Nessun dato chiaro su trattamenti più redditizi",                loss: "Vendi a intuito" },
    ],
    painFinal: { value: "~€7.500/anno", note: "Stima media: 3 no-show/sett × €50 cad" },
    smartPage: {
      brand: "Beauty Lounge Milano",
      tagline: "Estetica · Benessere · Manicure",
      logoIcon: Sparkles,
      reviews: 142,
    },
    waMessage: {
      patientName: "Anna",
      service: "Pulizia viso completa",
      duration: 60,
      operator: "Sara Lombardi",
      address: "Via Brera 8, Milano",
      day: "Mar 13 Maggio · 10:00",
    },
    recallTitle: "Recall clienti dormienti",
    recallSubtitle: "Clienti senza trattamenti da oltre 60 giorni",
    inactivePatients: [
      { name: "Alessia Rossi",  last: "ultimo trattamento 3 mesi fa", condition: "Pulizia viso", avatar: "AR" },
      { name: "Federica Greco", last: "ciclo concluso 4 mesi fa",     condition: "Trattamento corpo", avatar: "FG" },
      { name: "Marta Conti",    last: "ultima visita 2 mesi fa",      condition: "Manicure mensile", avatar: "MC" },
    ],
    recallStat: "+€1.500/mese",
    packages: [
      { name: "Pacchetto 5 Pulizie viso",  sessions: 5,  price: 240, savings: 35 },
      { name: "Pacchetto 10 Manicure",     sessions: 10, price: 250, savings: 50 },
      { name: "Trattamento corpo 6 sed.",  sessions: 6,  price: 480, savings: 90 },
    ],
    paksubtitle: "Crei pacchetti da 5, 6, 10 trattamenti. SmartBooker gestisce il saldo automaticamente e ti avvisa quando il cliente è al penultimo credito — vendi il rinnovo al momento giusto.",
    pkgClient: { name: "Federica Conti", pack: "Pacchetto 10 Manicure" },
    kpis: [
      { label: "Clienti attive",         value: "412",     trend: "+22%"   },
      { label: "Trattamenti erogati",    value: "684",     trend: "+28%"   },
      { label: "Fatturato del mese",     value: "€18.6k",  trend: "+34%"   },
      { label: "Riempimento cabine",     value: "94%",     trend: "+18pt"  },
      { label: "Recall riattivati",      value: "31",      trend: "+€1.5k" },
      { label: "No-show",                value: "4%",      trend: "-65%"   },
    ],
    finalGain: "+€11.000",
  },

  hair: {
    key: "hair",
    landingPath: "/hair",
    landingLabel: "SmartBooker · Parrucchieri",
    sectorParam: "barbiere",
    plan: "benessere_pro",
    title: "SmartBooker · Parrucchieri & Barbershop",
    seoTitle: "Demo SmartBooker per Parrucchieri e Barbershop",
    palette: {
      grad: "from-amber-500 to-orange-500",
      gradTo: "from-amber-600 to-orange-600",
      gradHover: "hover:from-amber-600 hover:to-orange-600",
      text: "text-amber-700",
      bg: "bg-amber-50",
      border: "border-amber-200",
      accent: "text-amber-600",
      ring: "ring-amber-400",
      icon: Scissors,
    },
    cover: {
      badge: "DEMO INTERATTIVA · Parrucchieri & Barber",
      h1Pre: "Salone pieno. Sempre.",
      h1Highlight: "Niente più telefono. Niente più assenze.",
      sub: "In 2 minuti vedi come SmartBooker organizza le prenotazioni di tutti i tuoi stylist — dalla prenotazione online al cliente che torna ogni 30 giorni in automatico.",
    },
    operators: [
      { name: "Marco Vitali",    role: "Stylist Senior",  color: "bg-amber-500"  },
      { name: "Luca Ferri",      role: "Barber",          color: "bg-orange-500" },
      { name: "Giulia Bianchi",  role: "Colorista",       color: "bg-rose-500"   },
    ],
    rooms: ["Postazione 1", "Postazione 2", "Postazione 3"],
    services: [
      { name: "Taglio Donna",                duration: 45, price: 30, highlight: false },
      { name: "Taglio + Piega",              duration: 60, price: 40, highlight: false },
      { name: "Colore + Taglio + Piega",     duration: 120, price: 75, highlight: true  },
      { name: "Taglio Uomo (Barber)",        duration: 30, price: 18, highlight: false },
      { name: "Barba + Rifinitura",          duration: 30, price: 15, highlight: false },
      { name: "Pacchetto Sposa",             duration: 90, price: 120, highlight: false },
    ],
    appointments: [
      { time: "09:30", room: 0, op: 0, service: "Taglio + Piega",          patient: "Sara Conti",    color: "bg-amber-100 dark:bg-amber-900/40 border-amber-500" },
      { time: "10:00", room: 1, op: 1, service: "Taglio Uomo",             patient: "Mario Greco",   color: "bg-orange-100 dark:bg-orange-900/40 border-orange-500" },
      { time: "10:30", room: 2, op: 2, service: "Colore + Taglio",         patient: "Laura Bianchi", color: "bg-rose-100 dark:bg-rose-900/40 border-rose-500" },
      { time: "11:30", room: 0, op: 0, service: "Taglio Donna",            patient: "Elena Russo",   color: "bg-amber-100 dark:bg-amber-900/40 border-amber-500" },
      { time: "15:00", room: 1, op: 1, service: "Barba + Rifinitura",      patient: "Luca Costa",    color: "bg-orange-100 dark:bg-orange-900/40 border-orange-500" },
      { time: "16:30", room: 2, op: 2, service: "Colore + Piega",          patient: "Anna Neri",     color: "bg-rose-100 dark:bg-rose-900/40 border-rose-500" },
    ],
    liveBooking: {
      time: "12:00", room: 0, op: 0,
      service: "Taglio Donna", patient: "Carla Verdi",
      color: "bg-emerald-100 dark:bg-emerald-900/40 border-emerald-500",
      label: "📲 Nuova prenotazione · Carla · 12:00",
    },
    pains: [
      { text: "Telefono che squilla durante un colore o un taglio",                loss: "12+ chiamate perse/giorno" },
      { text: "Clienti che non si presentano (specie weekend)",                    loss: "4-6 no-show a settimana" },
      { text: "Promemoria scritti a mano cliente per cliente",                     loss: "2 ore perse al giorno" },
      { text: "Clienti che cambiano salone dopo 2-3 visite",                       loss: "Tasso di abbandono ~50%" },
      { text: "Pacchetti gestiti a memoria o su WhatsApp",                         loss: "Crediti dimenticati" },
      { text: "Nessun dato sui servizi più richiesti né sull'orario migliore",     loss: "Riempi a casaccio l'agenda" },
    ],
    painFinal: { value: "~€9.000/anno", note: "Stima: 5 no-show/sett × €30 cad" },
    smartPage: {
      brand: "Studio Hair Vitali",
      tagline: "Parrucchieri · Barber · Colorista",
      logoIcon: Scissors,
      reviews: 198,
    },
    waMessage: {
      patientName: "Sara",
      service: "Taglio + Piega",
      duration: 60,
      operator: "Marco Vitali",
      address: "Via Garibaldi 22, Milano",
      day: "Mar 13 Maggio · 09:30",
    },
    recallTitle: "Recall clienti che non tornano",
    recallSubtitle: "Clienti senza visite da oltre 45 giorni",
    inactivePatients: [
      { name: "Alessandro Pini",  last: "ultimo taglio 2 mesi fa",  condition: "Taglio Uomo mensile", avatar: "AP" },
      { name: "Chiara Marini",    last: "ultimo colore 3 mesi fa",  condition: "Colore + Taglio",    avatar: "CM" },
      { name: "Roberto Greco",    last: "ultima barba 6 settimane", condition: "Barba bisettimanale", avatar: "RG" },
    ],
    recallStat: "+€1.800/mese",
    packages: [
      { name: "Pacchetto 5 Tagli Uomo",       sessions: 5,  price: 75,  savings: 15 },
      { name: "Pacchetto 8 Pieghe",           sessions: 8,  price: 200, savings: 40 },
      { name: "Pacchetto 5 Colori + Taglio",  sessions: 5,  price: 320, savings: 55 },
    ],
    paksubtitle: "Crei pacchetti da 5, 8 visite. SmartBooker gestisce il saldo automaticamente e ti avvisa quando il cliente è al penultimo credito — vendi il rinnovo prima che si dimentichi di tornare.",
    pkgClient: { name: "Lucia Ferri", pack: "Pacchetto 8 Pieghe" },
    kpis: [
      { label: "Clienti attivi",          value: "528",     trend: "+26%"   },
      { label: "Tagli + servizi mese",    value: "910",     trend: "+31%"   },
      { label: "Fatturato del mese",      value: "€21.4k",  trend: "+38%"   },
      { label: "Riempimento postazioni",  value: "96%",     trend: "+22pt"  },
      { label: "Recall riattivati",       value: "38",      trend: "+€1.8k" },
      { label: "No-show",                 value: "3%",      trend: "-72%"   },
    ],
    finalGain: "+€13.500",
  },
};
